__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/phx-rel-r25.12.1.1-121225/_next/";